import React from "react";

import shortNotation from "@/modules/shortNotation";
import { assetImg } from "@/modules/moduleImporter";
import img_cross from "@/assets/img/img_cross.png";
import { IGameType, ILanguageType } from "@/types/GlobalTypes";

interface IProps {
	activeGame: IGameType;
	langdata: ILanguageType;

	removeNumberM26: (e: any) => void;
	insertBet: (e: any) => void;
	removeBet: (e: any) => void;

	activateUnsubmittedTicketRow: (e: any) => void;
	addUnsubmittedTicketRow: (e: any) => void;

	mobile: boolean;
}

//COPIED FROM ShioBallsTable
export default class LottoTable extends React.Component<IProps> {
	render() {
		const activeGame = this.props.activeGame;
		const activeBetGroup = activeGame.activeBetGroup;
		const langdata = this.props.langdata;

		return (
			<div className="table-unsubmitted-tickets"
				{ ...{
					betgroup: activeBetGroup,
					pcode: "m26"
				}}>
				{
					this.props.mobile ? (
						<div className="header">
							{activeBetGroup}
						</div>
					) : null
				}

				<div className="scrollable-area">
					<table>
						<thead>
							{
								activeBetGroup ? (
								<tr>
									<td />
									<td>{langdata["txt_guess"]}</td>
									<td>{langdata["txt_bet"]}</td>
								</tr>
								) : null
							}
						</thead>

						<tbody>
							{
								activeBetGroup &&
								activeGame.groupedUnsubmittedTickets[activeBetGroup].map((item, idx) => {
									const betGroup = activeBetGroup;
									const isRandom = betGroup.indexOf("random") >= 0;
									const maximumNumberCount = isRandom ? 5 : 9;

									//const reversedNumberArray = item.numbers.slice(0, maximumNumberCount).reverse();
									const numberArray = item.numbers.slice(0, maximumNumberCount);

									const numberRowFunction = (num: number, numberIdx: number) => (
										(num !== null) ? (
											<div key={"nRF_" + idx + "_" + numberIdx}>
												{assetImg("m26", num + ".svg", "m26_" + idx + "_" + numberIdx)}

												<img className="delete"
													src={img_cross}

													{
														...{
															pcode: activeGame.pcode,
															ticketindex: idx,
															numberindex: numberIdx,
															group: activeBetGroup
														}
													}

													onClick={this.props.removeNumberM26}
													alt={"ball " + num}
												/>
											</div>
										) : (
												//Checks for colok and empty number circles
												<div key={"nRF_empty_" + idx + "_" + numberIdx} className="empty" />
										)
									);

									//Empty number check
									const hasEmptyNumberArray = activeGame.activeUnsubmittedTicketRow === idx &&
										numberArray.filter(num => num !== null).length === 0;

									//Empty bet check
									const hasEmptyBet = activeGame.activeUnsubmittedTicketRow === idx &&
										activeGame.groupedUnsubmittedTickets[activeBetGroup]
											[activeGame.activeUnsubmittedTicketRow].bet === 0;

									//Random and Order
									//Set first row
									return (
										<tr key={"MMG_m26_uT_" + idx}
											className={activeGame.activeUnsubmittedTicketRow === idx ? "active" : ""}

											{
												//to activate row
												...{
													pcode: activeGame.pcode,
													rowidx: idx
												}
											}
											onClick={this.props.activateUnsubmittedTicketRow}>
											<td>
												<div className="ticket-index">
													{idx + 1}
												</div>
											</td>


											{/* Guess column */}
											<td className={hasEmptyNumberArray ? "empty-guess" : ""}>
												{
													numberArray.map(numberRowFunction)
												}
											</td>

											{/* Bet column */}
											<td className={"sl-bet" + 
													(hasEmptyBet ? " blink" : "")}
												key={activeGame.pcode + "_" + activeBetGroup + "_" + idx}

												{
													...{
														index: idx,
														group: betGroup,
														pcode: activeGame.pcode
													}
												}

												onClick={this.props.insertBet}
											>
												<div className="bet-label">
													{
														betGroup === "order" ?
															shortNotation(item.bet) :
															item.bet
													}
												</div>

												<img className="delete"
													src={img_cross}

													{
														...{
															pcode: activeGame.pcode,
															ticketindex: idx,
															group: activeBetGroup
														}
													}

													onClick={this.props.removeBet}
													alt={"bet " + idx}
												/>
											</td>
										</tr>
									);
								})
							}

							{
								!activeBetGroup ?
									<tr key={"MMG_m26_uT_choose"}>
										<td>
											{this.props.langdata["txt_choose_bet_type"]}
										</td>
									</tr>


									//Empty Unsubmitted Tickets
									: (
										<tr key={"MMG_m26_uT_add"}

										{
											...{ pcode: activeGame.pcode }
										}
											onClick={this.props.addUnsubmittedTicketRow}

											className="add-ticket">
											<td colSpan={3}>
												{this.props.langdata["txt_add_tickets"]}
											</td>
										</tr>
									)
							}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}
